import {
  CARPENTRY_PAGE_URL,
  BATHROOMS_PAGE_URL,
  GROUNDWORKS_PAGE_URL,
  BUILDING_WORK_PAGE_URL,
} from '../Constants';
import TheIcon from '../../assets/images/icons/bath-bathtub-clean-svgrepo-com.svg';
import CarpentryIcon from '../../assets/images/icons/ruler-pencil-svgrepo-com.svg';
import TruckIcon from '../../assets/images/icons/truck-svgrepo-com.svg';
import WallIcon from '../../assets/images/icons/wall-icon.svg';

export const MainServicesArray = [
  { label: 'Carpentry', url: CARPENTRY_PAGE_URL },
  { label: 'Bathrooms', url: BATHROOMS_PAGE_URL },
  { label: 'Groundworks', url: GROUNDWORKS_PAGE_URL },
  { label: 'Building Work', url: BUILDING_WORK_PAGE_URL },
];
export const mainServicesDataArray = [
  {
    label: 'Carpentry',
    icon: CarpentryIcon,
    url: CARPENTRY_PAGE_URL,
    description:
      'From bespoke furniture to structural woodwork, our expert carpentry services ensure durability and aesthetic appeal in every project.',
  },
  {
    label: 'Bathrooms',
    icon: TheIcon,
    url: BATHROOMS_PAGE_URL,
    description:
      'We design and install high-quality bathrooms, handling everything from tiling to plumbing, creating luxurious and functional spaces.',
  },
  {
    label: 'Groundworks',
    icon: TruckIcon,
    url: GROUNDWORKS_PAGE_URL,
    description:
      'Laying the foundation for success, we provide expert groundworks services, including drainage, excavation, and site preparation.',
  },
  {
    label: 'Building Work',
    icon: WallIcon,
    url: BUILDING_WORK_PAGE_URL,
    description:
      'From extensions to renovations, we deliver exceptional building services tailored to your needs, ensuring structural integrity and style.',
  },
];
